module.exports = __webpack_public_path__ + "static/media/testimonial-bg.5124a89c.jpg";